import React, { useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import useStore from '../../Store/Store';
import PageHeader from '../../components/PageHeader';
import TabMenu from '../../components/TabMenu';
import FoodAnalysis from './components/FoodAnalysis';
import FoodMenuAnalysis from './components/FoodMenuAnalysis';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';

const NutritionAnalysis = () => {
  const width = useStore((state) => state.screenWidth);
  const { t } = useTranslation();

  const TAB_MENU = [t('foodAnalysis'), t('foodMenuAnalysis')];

  const [activeTab, setActiveTab] = useState(TAB_MENU[0]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case t('foodAnalysis'):
        return <FoodAnalysis />;
      case t('foodMenuAnalysis'):
        return <FoodMenuAnalysis />;
      default:
        return null;
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <div style={{ width: '240px', flexShrink: 0 }}>
        <SideBar />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <NewUserInfo isSideBar={false} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100vh',
            padding: '20px',
            boxSizing: 'border-box',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              maxWidth: '1200px',
              width: '100%',
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              height: '100%',
            }}
          >
            <PageHeader title={t('nutritionAnalysis')} />
            <TabMenu tabs={TAB_MENU} onTabClick={handleTabClick} activeTab={activeTab} />

            <div
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  padding: '24px',
                  flex: 1,
                  overflow: 'auto',
                }}
                className="hide-scroll"
              >
                {renderActiveTab()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NutritionAnalysis;
